import { supabase } from './supabase';

// Database initialization helper functions
export const initializeDatabase = async () => {
  try {
    console.log('Initializing database...');
    
    // Check if roles table exists and has data
    const { data: roles, error: rolesError } = await supabase
      .from('roles')
      .select('*');
    
    if (rolesError) {
      console.error('Error checking roles table:', rolesError);
      return { success: false, error: 'Failed to check database tables. Make sure you have run the SQL setup script.' };
    }
    
    if (!roles || roles.length === 0) {
      console.log('No roles found. You need to run the database setup script.');
      return { success: false, error: 'Database not initialized. Please run the SQL setup script in Supabase.' };
    }
    
    console.log('Database initialized with roles:', roles);
    return { success: true, roles };
    
  } catch (error) {
    console.error('Database initialization error:', error);
    return { success: false, error: error.message };
  }
};

// Test database connection
export const testDatabaseConnection = async () => {
  try {
    const { data, error } = await supabase
      .from('roles')
      .select('id')
      .limit(1);
    
    if (error) {
      console.error('Database connection test failed:', error);
      return false;
    }
    
    console.log('Database connection successful');
    return true;
  } catch (error) {
    console.error('Database connection error:', error);
    return false;
  }
};

// Create default roles if they don't exist (for development)
export const createDefaultRoles = async () => {
  try {
    const defaultRoles = [
      {
        name: 'member',
        description: 'Basic member access',
        permissions: { events: 'read', articles: 'read' },
        level: 3
      },
      {
        name: 'executive',
        description: 'Executive member with additional privileges',
        permissions: { events: 'write', articles: 'write', members: 'read' },
        level: 8
      },
      {
        name: 'admin',
        description: 'Full administrative access',
        permissions: { events: 'write', articles: 'write', members: 'write', roles: 'write', system: 'admin' },
        level: 10
      }
    ];

    for (const role of defaultRoles) {
      const { error } = await supabase
        .from('roles')
        .upsert(role, { onConflict: 'name' });
      
      if (error) {
        console.error(`Error creating role ${role.name}:`, error);
      }
    }

    console.log('Default roles created/updated successfully');
    return { success: true };
  } catch (error) {
    console.error('Error creating default roles:', error);
    return { success: false, error: error.message };
  }
};